<template>
  <pt-production-task-table class="pt-production-task-table__withData" ref="table" :selectType="selectType" :selectedKeys="selectedKeys" :request-data="getDataList" :page-size="pageSize" :total-number="Number(totalNumber)" :table-data="tableData" :layout="layout" :pageSizes="pageSizes" :tableLabels="tableLabels" v-on="$listeners" @size-change="handleSizeChange">
    <template slot-scope="scope">
      <slot :row="scope.row"></slot>
    </template>
  </pt-production-task-table>
</template>

<script>
import fillUrl from '@/mixins/fillUrl'
import PtProductionTaskTable from './index'
export default {
  name: 'pt-production-task-table__withData',
  components: {
    'pt-production-task-table': PtProductionTaskTable
  },
  mixins: [fillUrl],
  data () {
    return {
      pageSize: 10,
      totalNumber: 0,
      tableData: [],
      currentParams: this.params
    }
  },
  computed: {
    layout () {
      // if (this.isDialog) {
      //   return 'total, prev, pager, next,jumper'
      // }
      return 'sizes,total, prev, pager, next,jumper'
    },
    pageSizes () {
      // if (this.isDialog) {
      //   return []
      // }
      return [10, 25, 50, 100, 500, 1000, 2000]
    }
  },
  props: {
    tableLabels: {
      type: Array,
      default: () => []
    },
    selectType: {
      type: String,
      default: 'checkbox'
    },
    selectedKeys: {
      type: [String, Array],
      default: ''
    },
    params: {
      type: Object,
      default: () => {}
    },
    billId: {
      type: String,
      default: ''
    },
    onlyNoBill: Boolean,
    status: {
      type: String,
      default: null
    },
    isReceiveExamData: {
      type: Boolean,
      default: null
    },
    isOrderBack: {
      type: Boolean,
      default: null
    }
  },
  watch: {
    params (val) {
      this.currentParams = { ...val }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
    },
    filter (params) {
      this.currentParams = params

      this.fillUrl({ ...this.currentParams })
      this.$refs.table.resetPage()
    },
    buildParams (params) {
      const res = { ...params }
      Object.keys(res).forEach(key=>{
        if(!res[key]){
          res[key]=  null
        }
      })
      res.overDue = res.overDue && Boolean(res.overDue === 'true')  
      // res.settlement = res.settlement && Boolean(res.settlement === 'true')
      // res.invoice = res.invoice && Boolean(res.invoice === 'true')
      // res.back = res.back && Boolean(res.back === 'true')
      // res.urgent = res.urgent && Boolean(res.urgent === 'true')
      // res.deviate = res.deviate &&Boolean(res.deviate === 'true')
      // if(params.organizationId){
      //   res.organization = {
      //     id:params.organizationId
      //   }
      //   this.$delete(res,'organizationId')
      // }
      return res
    },
    getDataList (page, next) {
      const otherParams = this.buildParams(this.currentParams)
      let data = {
        pageable: {
          page: page,
          size: this.pageSize
        },
        onlyNoBill: this.onlyNoBill,
        status:this.status,
        ...otherParams,
        isReceiveExamData:this.isReceiveExamData,
        isOrderBack:this.isOrderBack,
        
      }
      if (this.billId) {
        data.billId = this.billId
      }
      this.$store.dispatch('getProductionTasksList', data).then(res => {
        next && next(res.data)
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.$emit('getAllSize', this.totalNumber)
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    },
    // 筛选数据的参数,不传默认为{}
    reload () {
      this.$refs.table.reload()
    }
  }
}
</script>
